import { render, staticRenderFns } from "./RemoteAttivoPublic.vue?vue&type=template&id=631e93de&scoped=true&"
import script from "./RemoteAttivoPublic.vue?vue&type=script&lang=js&"
export * from "./RemoteAttivoPublic.vue?vue&type=script&lang=js&"
import style0 from "./RemoteAttivoPublic.vue?vue&type=style&index=0&id=631e93de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631e93de",
  null
  
)

export default component.exports